import React, { Component } from 'react'
import './index.scss'
import Axios from '../../request'
import logo from '../../assets/logo.png'
import messageBoard from '../../assets/msgboard.png'
import { Toast } from 'antd-mobile'
export default class Message extends Component {
  state = {
    msgArr: [],
  }
  submitMsg = () => {
    const name = this.inputRef.value
    const msg = this.textareaRef.value
    if (!name.trim()) {
      Toast.info('请输入昵称', 1.5)
      return false
    }
    if (!msg.trim()) {
      Toast.info('留言不能为空', 1.5)
      return false
    }
    Axios.jsonp({ url: `/api/msg/add/24?name=${name}&content=${msg}` }).then(
      (res) => {
        if (res.result === 200) {
          Toast.success('成功，等待审核', 1.5)
          this.inputRef.value = ''
          this.textareaRef.value = ''
          this.getData()
        } else {
          Toast.fail(res.msg, 1.5)
          return false
        }
      }
    )
  }
  getData = () => {
    Axios.jsonp({ url: '/api/msg/list/24/15' }).then((res) => {
      this.setState({
        msgArr: res.obj.data.map((item) => ({
          id: item.id,
          name: item.name,
          time: item.createTime,
          cont: item.content,
        })),
      })
    })
  }
  inputBlur = () => {
    this.inputRef.blur()
    this.textareaRef.blur()
  }
  componentDidMount() {
    this.getData()
    this.conRef.addEventListener('click', (e) => {
      if (
        e.target &&
        (e.target.matches('input.nameInput') ||
          e.target.matches('textarea.contTextarea'))
      ) {
        return false
      }
      this.inputRef.blur()
      this.textareaRef.blur()
    })
  }
  render() {
    const { msgArr } = this.state
    return (
      <div
        className="conBox bg"
        data-component="messageBoard"
        ref={(c) => (this.conRef = c)}
      >
        {/* <img className="logo" src={logo} alt="logo" /> */}
        <img className="titleIcon" src={messageBoard} alt="logo" />
        <div className="mainBox">
          <input
            ref={(c) => (this.inputRef = c)}
            onClick={() => this.inputRef.focus()}
            type="text"
            className="nameInput"
            placeholder="请输入昵称"
          />
          <textarea
            ref={(c) => (this.textareaRef = c)}
            onClick={() => this.textareaRef.focus()}
            className="contTextarea"
            placeholder="留言:"
          ></textarea>
          <button type="button" className="submitBtn" onClick={this.submitMsg}>
             
          </button>
          <ul className="msgList">
            {msgArr.map((item) => (
              <li className="msgItem" key={item.id}>
                <div className="userName">网友：{item.name}</div>
                <div className="time">{item.time}</div>
                <div className="msg">{item.cont}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}
